module.exports = __webpack_public_path__ + "static/media/matrix-digital-rain.18553ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/matrix-digital-rain.png
// module id = 68
// module chunks = 0